import React, { useState } from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import { ISearchProduct, Replacement } from '../../../interface';
import style from './index.module.scss';
import paginatorConfig from '../../../config/paginatorConfig';
import localesReplacement from '../../../utils/localesReplacement';
import DOMPurify from 'dompurify';
import oilThumb from '../../../images/oil-thumb-placeholder.png';

export interface Props {
  dataList: ISearchProduct[];
  onSelect: (v: string) => void;
  replacements: Replacement;
}

const cx = classnames.bind(style);

function OilFilterResult(props: Props) {
  const { dataList, onSelect, replacements } = props;
  const [mPageIndex, setMPageIndex] = useState<number>(0);
  const limit = paginatorConfig.LIMIT;
  const mobileProducts = _.take(dataList, limit * (mPageIndex + 1));
  const showMore = () => {
    setMPageIndex(mPageIndex + 1);
  };
  return (
    <>
      {!_.isEmpty(dataList) && (
        <div className={cx('result')}>
          <p data-testid="product-count" className={cx('header')}> {dataList.length} {localesReplacement(replacements, "product(s) found.")} </p>
          {_.map(mobileProducts, (product, index) => (
            <div
              key={index}
              className={cx('result-row', 'mobile', 'product-trigger')}
              onClick={() => {
                onSelect(_.toString(product['id']));
              }}
            >
              <ul>
                <li>
                  <img
                    src={
                      Array.isArray(product['packartUrl'])
                        ? product['packartUrl'][0] || oilThumb
                        : product['packartUrl'] || oilThumb
                    }
                  />
                </li>
                <li
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(product['name']),
                  }}
                ></li>
              </ul>
            </div>
          ))}
          {!!dataList && mobileProducts.length < dataList.length && (
            <div className={cx('btn-show-more')}>
              <span data-testid="show-more" onClick={showMore}>
                {localesReplacement(replacements, 'Show more')}
              </span>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default OilFilterResult;
